export default __webpack_public_path__ + "static/media/check_circle_blue.03ec0419.svg";